<template>
  <div class="modal-card" :style="{minHeight: 60 + 'vh'}">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Manually upload distribution file
      </p>
      <button
        type="button"
        class="delete"
        @click="$emit('on-close')"
      />
    </header>
    <section class="modal-card-body">
      {{ distributor.id }}- {{ distributor.name }}
      <section class="mt-2">
        <b-field>
          <b-upload
            v-model="dropFiles"
            drag-drop
            @input="handleFileUpload"
          >
            <section class="section">
              <div class="content has-text-centered">
                <p>
                  <b-icon
                    icon="upload"
                    size="is-large"
                  />
                </p>
                <p>Drop your file here or click to upload</p>
              </div>
            </section>
          </b-upload>
        </b-field>

        <div class="tags">
          <span
            v-for="(file, index) in dropFiles"
            :key="index"
            class="tag is-primary"
          >
            {{ file.name }}
            <button
              class="delete is-small"
              type="button"
              @click="deleteDropFile(index)"
            />
          </span>
        </div>
      </section>

      <b-field class="mt-2">
        <b-checkbox v-model="hasNothing">
          Nothing to declare
        </b-checkbox>
      </b-field>
    </section>

    <footer class="modal-card-foot">
      <div class="buttons">
        <b-button type="is-primary" @click="submit">
          Submit
        </b-button>
        <b-button @click="$emit('on-close')">
          Cancel
        </b-button>
      </div>
    </footer>
  </div>
</template>

<script>
import Distribution from '../../services/v2/distribution'
import { mapState } from 'vuex'

export default {
  props: {
    distributor: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dropFiles: [],
      hasNothing: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  methods: {
    handleFileUpload (file) {
      this.dropFiles = file ? [file] : []
    },
    deleteDropFile (index) {
      this.dropFiles.splice(index, 1)
    },
    async submit () {
      if (this.dropFiles.length === 0 && !this.hasNothing) {
        this.$buefy.toast.open({
          message: 'Please upload a file or check "Nothing to declare".',
          type: 'is-danger'
        })
        return
      }

      const formData = new FormData()
      formData.append('file', this.dropFiles[0])
      formData.append('hasNothing', this.hasNothing)
      formData.append('uploadedBy', this.user.displayName)

      try {
        await Distribution.manualUploadDistrubution(this.distributor.id, formData)

        this.$buefy.toast.open({ message: 'Upload successfully', type: 'is-primary', duration: 4000 })

        this.$emit('on-close')
      } catch (e) {
        this.$buefy.toast.open({ message: e.message || e, type: 'is-danger', duration: 4000 })
      }
    }
  }
}
</script>
